module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    The map chart "), _c('i', {
    staticClass: "ui globe chart icon"
  }), _vm._v(" is not implemented in the prototype.  You can see how it will look in "), _c('a', {
    attrs: {
      "target": "_new",
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Detail+Page+Country+Breakdown.png"
    }
  }, [_vm._v("the design here")]), _vm._v(".\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-44f02a47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapChart.vue
// module id = 389
// module chunks = 1